(ns manage.campaign-tags-page.effect
  (:require [clojure.string :as str]
            [common.url-template :as url-tpl]
            [manage.campaign-tags-page.constant :as campaign-tags-page.constant]
            [mate.re-frame :as mr]
            [reitit.frontend.easy :as rfe]))

(defn set-campaign-tags-resource [effects resource]
  (-> effects
      (mr/update-db assoc :resource.campaign-tags/page resource)))

(defn remove-campaign-tags-resource [effects]
  (-> effects
      (mr/update-db dissoc :resource.campaign-tags/page)))

(defn set-campaign-tags-settings [effects campaign-tags-page]
  (-> effects
      (mr/update-db assoc :campaign-tags.page/settings (:filter-states campaign-tags-page))))

(defn create-campaign-tags-page [effects {:keys [token url-context
                                                 dsps additional-settings
                                                 extra-dsp-signals
                                                 advertiser-id adset-ids
                                                 on-success on-failure]}]
  (-> effects
      (mr/conj-fx [:http {:method :post
                          :uri (url-tpl/render :api/advertiser-campaign-tags-html url-context)
                          :params {:advertiser-id advertiser-id
                                   :adset-ids adset-ids
                                   :dsps dsps
                                   :gdpr (-> additional-settings :gdpr boolean)
                                   :extra-dsp-signals (or (keys extra-dsp-signals) [])
                                   :click-tag (-> additional-settings :click-tag boolean)
                                   :filter-states campaign-tags-page.constant/default-settings}
                          :headers {"Authorization" token}
                          :on-success on-success
                          :on-failure on-failure}])))

(defn get-campaign-tags-page [effects url-context token on-success on-failure]
  (-> effects
      (mr/conj-fx [:http {:method :get
                          :uri (url-tpl/render :api/advertiser-campaign-tags url-context)
                          :headers {"Authorization" token}
                          :on-success on-success
                          :on-failure on-failure}])))

(defn export-excel-tags [effects {:keys [token url-context
                                         dsps additional-settings
                                         extra-dsp-signals
                                         advertiser-id adset-ids
                                         on-success on-failure]}]
  (cond-> effects
    (not= (-> effects :db :resource.tags/tags :state) :pending)
    (-> (mr/update-db assoc :resource.tags/tags {:state :pending :value []})
        (mr/conj-fx [:http {:method :post
                            :response-format :binary+filename
                            :uri (url-tpl/render :api/advertiser-generate-tags-excel url-context)
                            :params {:advertiser-id advertiser-id
                                     :adset-ids adset-ids
                                     :dsps dsps
                                     :extra-dsp-signals (or (keys extra-dsp-signals) [])
                                     :gdpr (-> additional-settings :gdpr boolean)
                                     :click-tag (-> additional-settings :click-tag boolean)}
                            :headers {"Authorization" token}
                            :on-success on-success
                            :on-failure on-failure}]))))

(defn on-export-excel-tags-success [effects response]
  (-> effects
      (mr/update-db assoc :resource.tags/tags {:state :success})
      (mr/conj-fx [:binary/download (let [timestamp (-> (js/Date.)
                                                        (.toISOString)
                                                        (str/split #"T")
                                                        first
                                                        (str/replace "-" ""))]
                                      (update response :filename
                                              str/replace ".xlsx" (str "_" timestamp ".xlsx")))])))

(defn on-export-excel-tags-failure [effects _error]
  (-> effects
      (mr/update-db assoc :resource.tags/tags {:state :failure})
      (mr/conj-fx [:toaster-bus/add {:id ::get-tags
                                     :type :error
                                     :message "Error while getting the tags."}])))

(defn patch-campaign-tags-page [effects url-context token filter-states on-success on-failure]
  (-> effects
      (mr/conj-fx [:http {:method :patch
                          :uri (url-tpl/render :api/advertiser-campaign-tags url-context)
                          :params {:filter-states filter-states}
                          :headers {"Authorization" token}
                          :on-success on-success
                          :on-failure on-failure}])))

(defn open-campaign-tags-page [id]
  (rfe/set-query (fn [query-params]
                   (assoc query-params :campaign-tags id))))

(defn navigate-to-campaign-page [effects campaign-tags-id]
  (open-campaign-tags-page campaign-tags-id)
  effects)
